import { Box, Paragraph } from '@zillow/constellation-10';
import { CardImage, OverflowWrapHeading, OverflowWrapParagraph, SpacedCard } from './styles';
import enhanceVisibility from '../../../shared/images/olympus/enhance-visibility.svg';
import manageSeamlessly from '../../../shared/images/olympus/manage-seamlessly.svg';
import getSeriousLeads from '../../../shared/images/olympus/get-serious-leads.svg';
import stayFutureReady from '../../../shared/images/olympus/stay-future-ready.svg';

const cardsConfig = [
  {
    image: enhanceVisibility,
    title: 'Enhance visibility',
    description: 'Easily turn unadvertised properties into rich media listings on Zillow and HotPads.',
  },
  {
    image: manageSeamlessly,
    title: 'Manage seamlessly',
    description: 'Once claimed, listings stay accurate and hassle-free thanks to feed-enabled updates.',
  },
  {
    image: getSeriousLeads,
    title: 'Get serious leads',
    description: 'Receive HotPads leads right in your inbox from renters searching for your properties.',
  },
  {
    image: stayFutureReady,
    title: 'Stay future-ready',
    description: 'Get your properties ready for up to 20X more exposure* powered by flexible ad options.',
  },
];

export const ClaimYourListingDetails = ({ isFromModal = false }: { isFromModal?: boolean }) => (
  <>
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: {
          base: 'repeat(2, minmax(0, 1fr))',
          xl: isFromModal ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
        },
        gridAutoRows: '1fr',
        gap: '400',
      }}
    >
      {cardsConfig.map((card) => (
        <SpacedCard tone="neutral" key={card.title}>
          <CardImage src={card.image} alt={card.title} />
          <OverflowWrapHeading textStyle="heading-sm" level={6}>
            {card.title}
          </OverflowWrapHeading>
          <OverflowWrapParagraph textStyle="body">{card.description}</OverflowWrapParagraph>
        </SpacedCard>
      ))}
    </Box>
    <Paragraph textStyle="body-xs" css={{ marginTop: 'md', fontStyle: 'italic' }}>
      *Zillow Internal Data. Multifamily claimed listing performance. Total Impressions. May-June 2025.
    </Paragraph>
  </>
);

export default ClaimYourListingDetails;
